export default __webpack_public_path__ + "static/media/keto_dangers@3x.b77a4405.jpg";